import React from 'react';
import clsx from 'clsx';

const SliderNavigation = ({ canGoPrev, canGoNext, onPrevClick, onNextClick }) => {
  return (
    <div className='flex gap-3'>
      <div
        className={clsx('py-2 px-3 tag-background rounded flex justify-center items-center cursor-pointer', {
          'dim': !canGoPrev
        })}
        onClick={onPrevClick}
      >
        <svg className='rotate-180' width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.700048 11.8C0.516715 11.6167 0.425049 11.3833 0.425049 11.1C0.425049 10.8167 0.516715 10.5833 0.700048 10.4L3.18583 7.9142C3.96688 7.13315 3.96688 5.86682 3.18584 5.08577L0.700048 2.59999C0.516715 2.41665 0.425049 2.18332 0.425049 1.89999C0.425049 1.61665 0.516715 1.38332 0.700048 1.19999C0.883382 1.01665 1.11671 0.924988 1.40005 0.924988C1.68338 0.924988 1.91672 1.01665 2.10005 1.19999L6.70005 5.79999C6.80005 5.89999 6.87105 6.00832 6.91305 6.12499C6.95438 6.24165 6.97505 6.36665 6.97505 6.49999C6.97505 6.63332 6.95438 6.75832 6.91305 6.87499C6.87105 6.99165 6.80005 7.09999 6.70005 7.19999L2.10005 11.8C1.91672 11.9833 1.68338 12.075 1.40005 12.075C1.11671 12.075 0.883382 11.9833 0.700048 11.8Z" fill="white"/>
        </svg>
      </div>

      <div
        className={clsx('py-2 px-3 tag-background rounded flex justify-center items-center cursor-pointer', {
          'dim': !canGoNext
        })}
        onClick={onNextClick}
      >
        <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.700048 11.8C0.516715 11.6167 0.425049 11.3833 0.425049 11.1C0.425049 10.8167 0.516715 10.5833 0.700048 10.4L3.18583 7.9142C3.96688 7.13315 3.96688 5.86682 3.18584 5.08577L0.700048 2.59999C0.516715 2.41665 0.425049 2.18332 0.425049 1.89999C0.425049 1.61665 0.516715 1.38332 0.700048 1.19999C0.883382 1.01665 1.11671 0.924988 1.40005 0.924988C1.68338 0.924988 1.91672 1.01665 2.10005 1.19999L6.70005 5.79999C6.80005 5.89999 6.87105 6.00832 6.91305 6.12499C6.95438 6.24165 6.97505 6.36665 6.97505 6.49999C6.97505 6.63332 6.95438 6.75832 6.91305 6.87499C6.87105 6.99165 6.80005 7.09999 6.70005 7.19999L2.10005 11.8C1.91672 11.9833 1.68338 12.075 1.40005 12.075C1.11671 12.075 0.883382 11.9833 0.700048 11.8Z" fill="white"/>
        </svg>
      </div>
    </div>
  );
};

export default SliderNavigation;